(() => {
  if (customElements.get('related-product-recommendations')) return;
  class RelatedProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-related-variant]');
        if (!select || !select.value) return;
        const card = select.closest('[data-related-card]');
        const option = select instanceof HTMLSelectElement ? select.selectedOptions[0] : select;
        const membershipVariant = card.querySelector('[data-related-membership-id]');
        if (membershipVariant) membershipVariant.value = option.value;
        const price = card.querySelector('[data-related-price-container]');
        if (price.hasAttribute('ref')) price.dataset.regiosDoppGenericVariantId = option.value;
        price.dataset.priceOriginal = option.dataset.price;
        price.dataset.priceActual = option.dataset.price;
        price.dataset.priceCompare = option.dataset.compare || '';
        const regular = document.createElement('span');
        regular.className = 'spr-regular';
        regular.hidden = !option.dataset.compare;
        regular.textContent = option.dataset.compare || '';
        const sale = document.createElement('span');
        sale.className = 'spr-sale';
        sale.textContent = option.dataset.price;
        price.replaceChildren(regular, sale);
        card.querySelector('[data-price-from]')?.setAttribute('hidden', '');
        const plan = card.querySelector('[data-related-selling-plan]');
        if (plan) { plan.value = option.dataset.plan || ''; plan.disabled = !plan.value; }
        const component = card.querySelector('product-form-component');
        component.dataset.variantTitle = option.dataset.title;
        component.dataset.variantSku = option.dataset.sku;
        component.dataset.variantPrice = option.dataset.rawPrice;
        const link = card.querySelector('[data-related-view]');
        const url = new URL(link.href);
        url.searchParams.set('variant', option.value);
        link.href = url.href;
        window.dispatchEvent(new CustomEvent('regios-dopp:variant-change', {
          detail: { selectedVariant: { id: Number(option.value), price: Number(option.dataset.rawPrice) }, quantity: 1 }
        }));
      }, { signal });
      this.addEventListener('cart:update', (event) => {
        const component = event.target.closest('product-form-component');
        const card = component?.closest('[data-related-card]');
        if (!card) return;
        const status = card.querySelector('[data-related-message]');
        status.textContent = status.dataset.addedText;
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('related-product-recommendations', RelatedProductRecommendations);
})();
